import { Component, ElementRef, ViewChild, AfterViewInit, HostListener, OnDestroy, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { PedidosService, BillingHistoryRow } from 'src/app/services/pedidos.service';
import { AvatarService } from 'src/app/services/avatar.service'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ChangeDetectorRef, OnInit } from '@angular/core'; import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { MessageService } from 'primeng/api'; import { environment } from 'src/environments/environment';
import { MediaUploadService } from 'src/app/services/media-upload.service';
import { fromEvent } from 'rxjs'; import { ActivatedRoute, Router } from '@angular/router';

//import { loadStripe, Stripe, StripeElements } from '@stripe/stripe-js';
import type { Stripe, StripeElements } from '@stripe/stripe-js';

import { ConfirmationService } from 'primeng/api';
import { tap, catchError, finalize, filter } from 'rxjs/operators';
import { from, Observable, map } from 'rxjs';
import { ListCardsResponse, StripeCard } from 'src/app/models/cards';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn
} from '@angular/forms';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnDestroy, OnInit, AfterViewInit {
  private stripePromise: Promise<Stripe | null> | null = null;

  private getStripe(): Promise<Stripe | null> {
    if (!this.stripePromise) {
      this.stripePromise = import('@stripe/stripe-js')
        .then(m => m.loadStripe(environment.stripePublishableKey));
    }
    return this.stripePromise;
  }
  cards: StripeCard[] = [];
  loadingCards = false;
  pageOptions: any[] = [];

  activeOption: number = 1;
  pageConfigs?: any;
  user_name: string = '';
  user_sobrenome: string = '';
  chat_name: string = '';
  email: string = '';
  senha_atual: string = '';
  nova_senha: string = '';
  confirm_senha: string = '';
  logoPreviewUrl: any = null;
  logoSelected: boolean = false;
  sliderValueViews: number = 333;
  sliderValueSlicks: number = 0;
  sliderValueFeeds: number = 0;
  selectedFile: File | null = null;
  constructor(
    private pedidosService: PedidosService,
    public fb: FormBuilder,
    private router: Router,
    private errorHandler: ErrorHandlerService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private avatarService: AvatarService,
    private layoutService: LayoutService,
    private confirmationService: ConfirmationService,
    private injector: Injector,
    private mediaUploadService: MediaUploadService
  ) {
    console.log('[Capacitor] referenced in ProfileComponent');
    this.issueForm = this.fb.group({
      // defina os controles do formulário aqui
      // exemplo: 'name': ['']
    });
  }
  @ViewChild('fileUpload') fileUploadComponent!: any;
  @ViewChild('logoInput') logoInput!: ElementRef<HTMLInputElement>;

  triggerInput() {
    if (this.logoInput?.nativeElement) {
      this.logoInput.nativeElement.click();
    }
  }

  handleManualFileUpload(file: File): void {
    this.onLogoSelect({ files: [file] });
  }
  fileUploadIsValid: boolean = true;
  handleFileInvalid(reason: string) {
    this.fileUploadIsValid = false;

    if (reason === 'size') {
      this.erroTamanhoImagem = true;
      this.disableSave = true;
    }

    if (reason === 'type') {
      this.erroTipoImagem = true;
      this.disableSave = true;
    }

  }
  handleFileValid() {
    this.erroTamanhoImagem = false;
    this.erroTipoImagem = false;
    this.fileUploadIsValid = true;
    this.disableSave = !this.fileUploadIsValid || this.errorName; // opcional
  }


  onLogoSelect(event: any): void {
    this.erroTamanhoImagem = false;
    this.erroTipoImagem = false;
    if (event.files && event.files.length > 0) {
      this.selectedFile = event.files[0]; // Atribuir o arquivo selecionado à variável selectedFile
      // Se passou nas validações:

      // Validado — iniciar leitura
      if (this.selectedFile) {
        this.displaySidebar = true;

        this.delay(500);

        const reader = new FileReader();
        reader.onload = (e: any) => {
          const base64 = e.target.result;

          console.log('Base64 gerado:', base64);
          console.log('Arquivo selecionado:', this.selectedFile);
          console.log('Tamanho (bytes):', this.selectedFile!.size);
          console.log('Tipo MIME:', this.selectedFile!.type);

          // Força a verificação real da imagem (solução robusta para mobile)
          const testImage = new Image();
          testImage.onload = () => {
            this.logoPreviewUrl = base64;
            this.disableSave = !!this.errorName;
          };
          testImage.onerror = () => {
            console.warn('Erro ao carregar imagem no preview');
            this.logoPreviewUrl = null;
            this.disableSave = true;
          };

          testImage.src = base64;
        };

        reader.readAsDataURL(this.selectedFile);
      }
    } else {
      this.selectedFile = null; // Resetar selectedFile se nenhum arquivo for selecionado
      this.logoPreviewUrl = null;
    }
  }
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }





  removelogo(): void {
    this.displaySidebar = true;

    setTimeout(() => {
      this.manageOverlay();
    }, 1);

    this.logoPreviewUrl = null;
    this.selectedFile = null;
    this.showImageDeleteButton = false;
    this.disableSave = false;
  }
  @ViewChild('sidebar') sidebar!: ElementRef;



  isMobile: boolean = false;
  showRequiredError: boolean = false;
  ngAfterViewInit() {
  }

  changeEmal: boolean = false;
  emailFisrt?: string;
  user_id?: number;
  displaySidebar: boolean = false;

  manageOverlay() {
    const overlays = document.querySelectorAll('.p-component-overlay');
    const overlayEnters = document.querySelectorAll('.p-component-overlay-enter');

    overlays.forEach((overlay: Element) => {
      (overlay as HTMLElement).style.display = 'none';
    });

    overlayEnters.forEach((overlayEnter: Element) => {
      (overlayEnter as HTMLElement).style.display = 'none';
    });

    this.cdr.detectChanges();
  }
  manageOverlay2() {
    const overlay = document.querySelector('.p-component-overlay') as HTMLElement;
    if (this.displaySidebar) {
      overlay.style.display = 'block';
    }
  }
  toggleSidebar() {
    this.displaySidebar = false;
    setTimeout(() => {
      this.manageOverlay();
    }, 100);

  }
  subs_status?: string;
  displayAguarde: boolean = false;
  async ngOnInit() {

    // Este componente é carregado em https://app.slicksell.com.br/profile#subscription
    const isPopup = (window.name === 'ShopifyPopup') || (window.opener && window.opener !== window);
    const isShopifySub = window.location.hash.includes('#subscription');


    console.log('isPopup 2 ', isPopup);
    console.log('isShopifySub 2', isShopifySub);

    if (isShopifySub) {
      console.log('popup com subscription');

      // Sempre envie a mensagem
      try {
        const channel = new BroadcastChannel('oauth-channel');
        channel.postMessage({ type: 'shopify-connected' });
        setTimeout(() => channel.close(), 100);
      } catch (err) {
        console.error('Erro ao enviar mensagem via BroadcastChannel:', err);
      }

      // Tenta fechar a popup depois de um pequeno delay
      setTimeout(() => {
        window.close();
      }, 150);

      // Como fallback, caso a janela não feche (exemplo: Safari bloqueia)
      setTimeout(() => {
        window.location.href = 'about:blank';
      }, 1000);
    } else {
      console.log('não é popup com subscription');
    }
    this.displayAguarde = true;

    this.isMobile = window.innerWidth <= 768;

    this.pageOptions = [
      { name: 'Infos', value: 1 },
      { name: 'Segurança', value: 2 },
      { name: 'Assinatura', value: 3 },
    ];

    // Captura o fragmento da URL (ex: #subscription)
    this.route.fragment.subscribe((fragment) => {
      if (fragment === 'feed_subs') {
        // Seleciona automaticamente "Assinatura" se o fragmento for "#subscription"
        this.pageConfigs = this.pageOptions.find(option => option.name === 'Assinatura');
        this.activeOption = 3;
      } else {
        // Caso contrário, mantém a opção padrão
        this.pageConfigs = this.pageOptions[0];
      }
    });

    ///////////////////////
    const billing = this.route.snapshot.queryParamMap.get('billing');
    const result = this.route.snapshot.queryParamMap.get('result');

    if (billing === 'stripe' && result) {
      this.activeOption = 3;
      if (result === 'success') {
        this.messageService.add({
          severity: 'success',
          summary: 'Assinatura criada/atualizada',
          detail: 'Pagamento confirmado com sucesso.',
        });
      } else if (result === 'cancel') {
        this.messageService.add({
          severity: 'warn',
          summary: 'Pagamento cancelado',
          detail: 'Você cancelou o checkout.',
        });
      }

      // ✅ remove os params pra não mostrar toast de novo em F5
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { billing: null, result: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    } else if (billing === 'shopify' && result === 'success') {
      this.activeOption = 3;
      this.messageService.add({
        severity: 'success',
        summary: 'Assinatura criada/atualizada',
        detail: 'Pagamento confirmado com sucesso.',
      });

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { billing: null, result: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
    ///////////////////////

    let user_id = localStorage.getItem('user_id');
    if (user_id === null) {
      console.error('User ID is not available in localStorage');
      // Você pode tratar esse caso como achar melhor
    } else {
      let numericUserId = parseInt(user_id, 10);
      this.user_id = numericUserId;
      try {
        // Cache-first com ETag (src/app/core/http-cache).
        const userResource = this.pedidosService.detailUserRevalidated(numericUserId);

        toObservable(userResource.data, { injector: this.injector }).pipe(
          filter((response): response is any => response !== null)
        ).subscribe(response => {
            this.user_name = response.name;
            this.user_sobrenome = response.surname;
            this.chat_name = response.username;
            this.email = response.email;
            this.emailFisrt = response.email;
            if (response.photo) {
              const photoUrl = response.photo.split('?')[0];
              this.logoPreviewUrl = photoUrl;
              this.imgUrl = photoUrl;
            }
            this.displayAguarde = false;
            this.toggleSidebar();
        });

        toObservable(userResource.error, { injector: this.injector }).pipe(
          filter((err): err is any => err !== null)
        ).subscribe(() => {
            this.displayAguarde = false;
        });
      } catch (e) {
        this.displayAguarde = false;
        console.error('Erro ao buscar detalhes do usuário:', e);
      }
    }

    /// quantidade de slicks countslicks — cache-first com ETag.
    const countSlicksResource = this.pedidosService.countSlicksRevalidated();

    toObservable(countSlicksResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null)
    ).subscribe(res => {
        console.log('Slicks e Views', res);

        // Configurando o slider de Slicks
        if (res.slicks > 10) {
          this.sliderValueSlicks = 10;
          this.showCountSlicks = false;
        } else {
          this.sliderValueSlicks = res.slicks;
          this.showCountSlicks = true; // Mostra o valor dos slicks quando for <= 10
        }
        this.sliderValueSlicks = res.slicks;
        this.sliderValueFeeds = res.feeds;
        // Configurando o slider de Views
        if (res.views > 1000) {
          this.sliderValueViews = 1000; // Limite para o slider de views
          this.showCountViews = false;
        } else {
          this.sliderValueViews = res.views;
          this.showCountViews = true;
        }
        this.sliderValueViews = res.views;
    });

    toObservable(countSlicksResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(error => {
        console.error("Erro ao buscar dados de Slicks e Views:", error);
    });

    // Cache-first com ETag.
    const plansResource = this.pedidosService.plansRevalidated();

    toObservable(plansResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null)
    ).subscribe(res => {
        console.log('Planos', res);
        /////////////
        // Converter os preços para reais
        this.freePlanPrice = this.formatCurrency(parseFloat(res.free_plan_price));
        this.starterPlanPrice = this.formatCurrency(parseFloat(res.starter_plan_price));
        this.proPlanPrice = this.formatCurrency(parseFloat(res.pro_plan_price));
        this.enterprisePlanPrice = this.formatCurrency(parseFloat(res.enterprise_plan_price));

        // Converter visualizações para número formatado
        this.freePlanViews = this.formatNumber(parseFloat(res.free_plan_views));
        this.starterPlanViews = this.formatNumber(parseFloat(res.starter_plan_views));
        this.proPlanViews = this.formatNumber(parseFloat(res.pro_plan_views));
        this.enterprisePlanViews = this.formatNumber(parseFloat(res.enterprise_plan_views));



        this.free_plan_videos_count = res.free_plan_videos_count;
        this.starter_plan_videos_count = res.starter_plan_videos_count;
        this.pro_plan_videos_count = res.pro_plan_videos_count;
        this.enterprise_plan_videos_count = res.enterprise_plan_videos_count;


        this.free_plan_views_count = res.free_plan_views_count;
        this.starter_plan_views_count = res.starter_plan_views_count;
        this.pro_plan_views_count = res.pro_plan_views_count;
        this.enterprise_plan_views_count = res.enterprise_plan_views_count;

        // Outras variáveis
        this.hasShopify = res.hasShopify;
        this.userSubType = res.user_sub_type;
        this.subs_status = res.subs_status;
        this.updateViewSubscriptionFlag();

        console.log('dados 0')
        console.log(this.subs_status)
        console.log(this.userSubType)
        /////////////
        if (this.userSubType == 0) {
          this.plan = 'Free';
          this.views_total = this.free_plan_views_count;
          this.slicks_total = this.free_plan_videos_count;
          this.feeds_total = this.free_plan_videos_count;
        } else if (this.userSubType == 1) {
          this.plan = 'Starter';
          this.views_total = this.starter_plan_views_count;
          this.slicks_total = this.starter_plan_videos_count;
          this.feeds_total = this.starter_plan_videos_count;
        } else if (this.userSubType == 2) {
          this.plan = 'Pro';
          this.views_total = this.pro_plan_views_count;
          this.slicks_total = this.pro_plan_videos_count;
          this.feeds_total = this.pro_plan_videos_count;
        } else if (this.userSubType == 3) {
          this.plan = 'Enterprise';
          this.views_total = this.enterprise_plan_views_count;
          this.slicks_total = this.enterprise_plan_videos_count;
          this.feeds_total = this.enterprise_plan_videos_count;
        } else {

        }
    });

    toObservable(plansResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(error => {
        console.error("Erro ao buscar dados de {Planos}:", error);
    });


    /////////////////
    // Cache-first com ETag.
    const storeIntegrationResource = this.pedidosService.getStoreIntegrationRevalidated('shopify');

    toObservable(storeIntegrationResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null)
    ).subscribe(res => {
        console.log('store integration:', res);

        // se achou integração ativa (shopify ou nuvemshop), então NÃO precisa criar app
        this.createApp = !res?.found;
        this.foundPlatform = res?.found;
        this.updateViewSubscriptionFlag();

        // se você quiser saber qual plataforma foi encontrada:
        this.platform = res?.platform; // 'shopify' | 'nuvemshop' | null

        // se precisar do domínio/URL da loja
        // this.urlStore = res?.url_store;

        console.log('createApp')
        console.log(this.createApp)

        console.log('dados 1')
        console.log(this.platform)
        console.log(this.foundPlatform)
    });

    toObservable(storeIntegrationResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(error => {
        console.error('Erro ao buscar integração da loja:', error);
        // se deu erro, comportamento seguro: exigir criação
        this.createApp = true;
        this.foundPlatform = false;
        this.updateViewSubscriptionFlag();
    });

    this.loadCards();
    this.loadHistory();


  }
  defaultPaymentMethodId: string | null = null;

  async loadCards(): Promise<void> {
    const selectedUserId = localStorage.getItem('user_id') || '';
    const user_id = Number(selectedUserId);

    if (!user_id) return;

    this.loadingCards = true;

    try {
      // Cache-first com ETag.
      const cardsResource = this.pedidosService.listCardsRevalidated(user_id);

      toObservable(cardsResource.data, { injector: this.injector }).pipe(
        filter((res): res is any => res !== null)
      ).subscribe(res => {

          const fake_cars = {
            "cards": [
              {
                "id": "pm_1Spb747tku4TFCkCQeb03VkI",
                "object": "payment_method",
                "allow_redisplay": "limited",
                "billing_details": {
                  "address": {
                    "city": null,
                    "country": "BR",
                    "line1": null,
                    "line2": null,
                    "postal_code": null,
                    "state": null
                  },
                  "email": "marketing@krabo.io",
                  "name": "qualquer nome",
                  "phone": null,
                  "tax_id": null
                },
                "card": {
                  "brand": "visa",
                  "checks": {
                    "address_line1_check": null,
                    "address_postal_code_check": null,
                    "cvc_check": "pass"
                  },
                  "country": "US",
                  "display_brand": "visa",
                  "exp_month": 12,
                  "exp_year": 2034,
                  "fingerprint": "sSGknvSZ5ShpGK09",
                  "funding": "credit",
                  "generated_from": null,
                  "last4": "4242",
                  "networks": {
                    "available": [
                      "visa"
                    ],
                    "preferred": null
                  },
                  "regulated_status": "unregulated",
                  "three_d_secure_usage": {
                    "supported": true
                  },
                  "wallet": {
                    "dynamic_last4": null,
                    "link": [],
                    "type": "link"
                  }
                },
                "created": 1768424182,
                "customer": "cus_TnBTF7gRcMJjCD",
                "customer_account": null,
                "livemode": false,
                "metadata": [],
                "type": "card"
              },
              {
                "id": "pm_1Spb747tku4TFCkCQeb03VkI",
                "object": "payment_method",
                "allow_redisplay": "limited",
                "billing_details": {
                  "address": {
                    "city": null,
                    "country": "BR",
                    "line1": null,
                    "line2": null,
                    "postal_code": null,
                    "state": null
                  },
                  "email": "marketing@krabo.io",
                  "name": "qualquer nome",
                  "phone": null,
                  "tax_id": null
                },
                "card": {
                  "brand": "visa",
                  "checks": {
                    "address_line1_check": null,
                    "address_postal_code_check": null,
                    "cvc_check": "pass"
                  },
                  "country": "US",
                  "display_brand": "visa",
                  "exp_month": 12,
                  "exp_year": 2034,
                  "fingerprint": "sSGknvSZ5ShpGK09",
                  "funding": "credit",
                  "generated_from": null,
                  "last4": "4242",
                  "networks": {
                    "available": [
                      "visa"
                    ],
                    "preferred": null
                  },
                  "regulated_status": "unregulated",
                  "three_d_secure_usage": {
                    "supported": true
                  },
                  "wallet": {
                    "dynamic_last4": null,
                    "link": [],
                    "type": "link"
                  }
                },
                "created": 1768424182,
                "customer": "cus_TnBTF7gRcMJjCD",
                "customer_account": null,
                "livemode": false,
                "metadata": [],
                "type": "card"
              }
              ,
              {
                "id": "pm_1Spb747tku4TFCkCQeb03VkI",
                "object": "payment_method",
                "allow_redisplay": "limited",
                "billing_details": {
                  "address": {
                    "city": null,
                    "country": "BR",
                    "line1": null,
                    "line2": null,
                    "postal_code": null,
                    "state": null
                  },
                  "email": "marketing@krabo.io",
                  "name": "qualquer nome",
                  "phone": null,
                  "tax_id": null
                },
                "card": {
                  "brand": "visa",
                  "checks": {
                    "address_line1_check": null,
                    "address_postal_code_check": null,
                    "cvc_check": "pass"
                  },
                  "country": "US",
                  "display_brand": "visa",
                  "exp_month": 12,
                  "exp_year": 2034,
                  "fingerprint": "sSGknvSZ5ShpGK09",
                  "funding": "credit",
                  "generated_from": null,
                  "last4": "4242",
                  "networks": {
                    "available": [
                      "visa"
                    ],
                    "preferred": null
                  },
                  "regulated_status": "unregulated",
                  "three_d_secure_usage": {
                    "supported": true
                  },
                  "wallet": {
                    "dynamic_last4": null,
                    "link": [],
                    "type": "link"
                  }
                },
                "created": 1768424182,
                "customer": "cus_TnBTF7gRcMJjCD",
                "customer_account": null,
                "livemode": false,
                "metadata": [],
                "type": "card"
              }
            ]
          }


          this.cards = res?.cards ?? [];
          this.defaultPaymentMethodId = res?.default_payment_method ?? null;
          this.loadingCards = false;

      });

      toObservable(cardsResource.error, { injector: this.injector }).pipe(
        filter((err): err is any => err !== null)
      ).subscribe(err => {
          console.error('Erro ao listar cards:', err);
          this.loadingCards = false;
      });
    } catch (e) {
      console.error('Erro ao preparar request de listCards:', e);
      this.loadingCards = false;
    }
  }
  onToggleDefaultCard(card: any, event: any) {
    const checked = !!event?.checked;
    const pmId = card?.id;
    if (!pmId) return;

    // Só reage quando ligou
    if (!checked) {
      // se quiser impedir desligar, só recarrega estado visual
      return;
    }

    this.setDefaultCard(pmId);
  }

  async setDefaultCard(pmId: string) {
    this.loadingCards = true;

    try {
      const obs = await this.pedidosService.setDefaultCard(pmId, this.customerId ?? null);
      obs.subscribe({
        next: async () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Cartão padrão atualizado',
            detail: 'O cartão foi definido como padrão.',
          });
          await this.loadCards(); // ✅ atualiza default + lista
        },
        error: (err) => {
          this.loadingCards = false;
          this.errorHandler.handle(err, 'Falha ao definir cartão padrão.');
        }
      });
    } catch (e) {
      this.loadingCards = false;
      console.error(e);
    }
  }

  isDefaultCard(card: any): boolean {
    return !!this.defaultPaymentMethodId && card?.id === this.defaultPaymentMethodId;
  }

  async openBillingPortal(ev?: Event): Promise<void> {
    ev?.stopPropagation();

    const user_id_tmp = localStorage.getItem('user_id') || '';
    const user_id = Number(user_id_tmp);
    if (!user_id) return;

    try {
      const obs = await this.pedidosService.billingPortal(user_id);
      obs.subscribe({
        next: (res) => {
          const url = res?.portal_url;
          if (url) window.open(url, '_blank');
        },
        error: (err) => console.error('Erro ao abrir billing portal:', err)
      });
    } catch (e) {
      console.error('Erro ao preparar request billingPortal:', e);
    }
  }

  getBrandIcon(card: any): string {
    const brand = (card?.card?.brand || '').toLowerCase();

    const map: Record<string, string> = {
      visa: 'visa',
      mastercard: 'mastercard',
      amex: 'amex',
      american_express: 'amex',
      elo: 'elo',
      hipercard: 'hipercard',
      diners: 'diners',
      diners_club: 'diners',
      discover: 'discover',
      jcb: 'jcb',
      unionpay: 'unionpay',
    };

    const key = map[brand] || 'default';
    return `assets/card-brands/${key}.svg`;
  }

  trackByCardId = (_: number, item: StripeCard) => item.id;
  /** texto/ícone da bandeira sem lib */
  getBrandLabel(card: StripeCard): string {
    const brand = (card.card?.brand || '').toLowerCase();
    const map: Record<string, string> = {
      visa: 'VISA',
      mastercard: 'MASTERCARD',
      amex: 'AMEX',
      american_express: 'AMEX',
      elo: 'ELO',
      hipercard: 'HIPERCARD',
      diners: 'DINERS',
      diners_club: 'DINERS',
      discover: 'DISCOVER',
      jcb: 'JCB',
      unionpay: 'UNIONPAY'
    };
    return map[brand] || (brand ? brand.toUpperCase() : 'CARD');
  }

  getDisplayName(card: StripeCard): string {
    return card.billing_details?.name || 'Cartão';
  }

  getMaskedNumber(card: StripeCard): string {
    const last4 = card.card?.last4 || '----';
    return `•••• •••• •••• ${last4}`;
  }

  getExpiry(card: StripeCard): string {
    const m = card.card?.exp_month;
    const y = card.card?.exp_year;
    if (!m || !y) return '--/--';
    const mm = String(m).padStart(2, '0');
    const yy = String(y).slice(-2);
    return `${mm}/${yy}`;
  }

  store_id?: number;
  createApp: boolean = false;
  foundPlatform: boolean = false;
  platform: string | null = 'nuvemshop';
  newSubscriptionType: number = 0;

  shouldShowViewSubscription: boolean = false;
  isActiveSubscription: boolean = false;

  private updateViewSubscriptionFlag(): void {
    const normalizedStatus = String(this.subs_status ?? '').trim().toUpperCase();
    this.isActiveSubscription = normalizedStatus === 'ACTIVE' || normalizedStatus === 'TRIALING';
    this.shouldShowViewSubscription = this.isActiveSubscription
      && this.userSubType != null
      && this.userSubType !== 0;
  }

  viewSubscription(n: number): void {
    if (this.platform == 'nuvemshop') {
      this.createSubscription(n)
    }
  }


  private startOAuthPopupListener(): void {
    if (this.oauthChannel) return; // Evita múltiplos listeners
    this.oauthChannel = new BroadcastChannel('oauth-channel');

    this.oauthChannel.onmessage = (event) => {
      if (event.data?.type === 'shopify-connected') {
        setTimeout(() => {
          try { this.oauthChannel?.close(); } catch { }
          this.oauthChannel = null;
          window.focus();
          window.location.reload();
        }, 0);
      }
    };
  }


  createSubscription(n: number) {
    if (this.loadingSub[n]) return;
    this.setLoading(n, true);

    let price = '0';
    let planName = '';
    let text_terms = '';

    if (n === 1) { planName = 'Starter'; price = this.starterPlanPrice; text_terms = this.starterPlanViews + ' por view extra'; }
    else if (n === 2) { planName = 'Pro'; price = this.proPlanPrice; text_terms = this.proPlanViews + ' por view extra'; }
    else if (n === 3) { planName = 'Enterprise'; price = this.enterprisePlanPrice; text_terms = this.enterprisePlanViews + ' por view extra'; }

    this.stripePayPlanPrice = price; // salva formatado (ex: "R$ 97,70") antes do replace

    const isNuvemshopOrNull = !this.platform || this.platform === 'nuvemshop'; // 123
    const isShopify = this.platform === 'shopify';

    this.newSubscriptionType = n;
    price = price.replace(/[^\d,.]/g, '').replace(',', '.');
    const parsedPrice = parseFloat(price);

    const payload: any = {
      name: planName,
      returnUrl: isNuvemshopOrNull
        ? 'https://app.slicksell.com.br'
        : (isShopify
          ? 'https://app.slicksell.com.br/profile?billing=shopify&result=success'
          : 'https://app.slicksell.com.br/profile#subscription'),
      price: parsedPrice,
      platform: this.platform,
      found: this.createApp,
      currency: 'USD',
      interval: 'EVERY_30_DAYS',
      cappedAmount: 100.00,
      terms: text_terms
    };

    // Nuvemshop: se já tem cartão salvo, passa para cobrar diretamente
    if (isNuvemshopOrNull && this.defaultPaymentMethodId) {
      payload.payment_method_id = this.defaultPaymentMethodId;
    }

    // Shopify: sem popup. Redireciona na mesma aba para o confirmation_url.
    if (isShopify) {
      this.createNewSubscription(payload, n, null);
      return;
    }

    this.stripePayPlanName = planName;

    // Pré-abre popup em branco antes da chamada API para evitar bloqueio do browser
    this.startOAuthPopupListener();
    this.setupStorageBridgeForPopup();
    const paymentPopup = this.openBlankPaymentPopup();

    this.createNewSubscription(payload, n, paymentPopup);
  }

  private openBlankPaymentPopup(): Window | null {
    const w = window.screen.width;
    const h = window.screen.height;

    // mantém o mesmo "name" para reutilizar a janela
    const popup = window.open('', 'StripePayment', `width=${w},height=${h},left=0,top=0`);

    if (!popup) {
      return null;
    }

    try {
      popup.document.write(`
        <div style="font-family: Arial; padding: 24px;">
          <h3>Carregando pagamento...</h3>
        </div>
      `);
    } catch { }

    return popup;
  }

  private watchPopupClose(popup: Window | null, onClosed: () => void) {
    if (!popup) return;

    const interval = window.setInterval(() => {
      if (popup.closed) {
        window.clearInterval(interval);
        onClosed();
      }
    }, 500);
  }


  // Método auxiliar para criar a nova assinatura
  // Método auxiliar para criar a nova assinatura
  private async createNewSubscription(payload: any, n: number, paymentPopup: Window | null) {
    const observable = await this.pedidosService.createSubscription(payload);

    observable.subscribe({
      next: (res) => {
        console.log('retorno create');
        console.log(res);

        this.setLoading(n, false);

        // ✅ Caso cartão salvo cobrado direto (sem formulário)
        if (res?.payment?.requires_payment === false && res?.payment?.hosted_invoice_url) {
          try { paymentPopup?.close(); } catch { }
          this.openInvoiceDialog(res.payment.hosted_invoice_url);
          return;
        }

        // ✅ Caso upgrade Stripe: hosted invoice / client_secret
        if (res?.payment?.requires_payment) {
          const hosted = res?.payment?.hosted_invoice_url;
          const cs = res?.payment?.client_secret;

          if (cs) {
            // fecha popup vazia, porque vai abrir modal interno
            try { paymentPopup?.close(); } catch { }
            this.openStripePayment(cs, res?.payment?.payment_intent_id ?? '');
            return;
          }

          if (hosted) {
            let upgradePopup = paymentPopup;
            if (!upgradePopup) {
              const w = window.screen.width;
              const h = window.screen.height;
              upgradePopup = window.open(hosted, 'StripeUpgrade', `width=${w},height=${h},left=0,top=0`);
            } else {
              upgradePopup.location.href = hosted;
            }

            this.watchPopupClose(upgradePopup, () => {
              localStorage.setItem('stripe_upgrade_closed', '1');
              window.location.reload();
            });
            return;
          }

        }

        // ✅ Caso assinatura inicial (Stripe Checkout)
        const checkoutUrl = res?.payment?.checkout_url;
        if (checkoutUrl) {
          if (paymentPopup) {
            // ✅ aqui é a correção: usar postMessage (StripeSuccessComponent)
            this.openStripeCheckoutInPopup(paymentPopup, checkoutUrl);
          } else {
            // fallback
            this.openStripeCheckoutPopup(checkoutUrl);
          }
          return;
        }

        // ✅ Billing Portal
        const portalUrl = res?.payment?.portal_url;
        if (portalUrl) {
          let portalPopup = paymentPopup;
          if (!portalPopup) {
            const w = window.screen.width;
            const h = window.screen.height;
            portalPopup = window.open(portalUrl, 'StripePortal', `width=${w},height=${h},left=0,top=0`);
          } else {
            portalPopup.location.href = portalUrl;
          }

          this.watchPopupClose(portalPopup, () => {
            localStorage.setItem('stripe_portal_closed', '1');
            window.location.reload();
          });
          return;
        }


        // ✅ Shopify flow
        if (res && res.confirmation_url) {
          try { paymentPopup?.close(); } catch { }

          const url = res.confirmation_url as string;
          if (Capacitor.isNativePlatform()) {
            void Browser.open({ url });
          } else {
            window.location.assign(url);
          }

          return;
        }

        try { paymentPopup?.close(); } catch { }
        console.error('Erro: Resposta inválida do servidor.', res);
      },

      error: (error) => {
        this.setLoading(n, false);

        try { paymentPopup?.close(); } catch { }

        // Nuvemshop: exibe erro direto, sem tentar OAuth do Shopify
        if (payload?.platform !== 'shopify') {
          this.errorHandler.handle(error, 'Falha ao processar assinatura.');
          return;
        }

        // Shopify: fallback OAuth
        const errorMessage = error?.error ?? 'Erro desconhecido';

        this.startOAuthPopupListener();
        this.setupStorageBridgeForPopup();

        const isNative = Capacitor.isNativePlatform();
        const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
        let stateObj: any = { selectedStoreId };

        if (isNative) {
          const accessToken = localStorage.getItem('access_token') || '';
          stateObj.accessToken = accessToken;
        }

        stateObj.nonce = Math.random().toString(36).substring(2);
        const state = btoa(JSON.stringify(stateObj));

        const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/shopify');
        const authUrl =
          'https://slicksell-test.myshopify.com/admin/oauth/authorize?' +
          `client_id=0d45482ed6adf4a59e4e8fc7f367b9ab` +
          `&scope=read_content,read_discounts,read_gift_cards,read_inventory,read_orders,read_products,read_themes,write_pixels,write_products,write_script_tags,write_themes` +
          `&redirect_uri=${redirectUri}` +
          `&state=${state}`;

        if (isNative) {
          void Browser.open({ url: authUrl });
        } else {
          window.location.assign(authUrl);
        }

        this.errorHandler.handle(error, typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage));
      }
    });
  }

  //openStripeCheckoutInPopup
  /**
 * ✅ Reaproveita a popup em branco para o Stripe Checkout
 * - escuta postMessage do StripeSuccessComponent/StripeCancelComponent
 * - só mostra toast no success (billing=stripe&result=success)
 */
  private openStripeCheckoutInPopup(popup: Window, checkoutUrl: string) {
    popup.location.href = checkoutUrl;

    const onMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://app.slicksell.com.br') return;

      const data = event.data;
      if (!data || data.type !== 'STRIPE_CHECKOUT_DONE') return;

      window.removeEventListener('message', onMessage);

      try { popup.close(); } catch { }

      const ok = data.result === 'success';

      // ✅ você pediu: toast só no success
      if (ok) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { billing: 'stripe', result: 'success' },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        }).then(() => window.location.reload());
      } else {
        // cancel/closed -> só recarrega, sem param (sem toast)
        window.location.reload();
      }
    };

    window.addEventListener('message', onMessage);

    // fallback: fechou no X sem passar pelo success/cancel
    const interval = window.setInterval(() => {
      if (popup.closed) {
        window.clearInterval(interval);
        window.removeEventListener('message', onMessage);

        // sem toast, só recarrega para refletir status
        window.location.reload();
      }
    }, 500);
  }
  /**
 * Fallback antigo (abre popup direto).
 * Mantém aqui caso paymentPopup venha null.
 */
  private openStripeCheckoutPopup(url: string) {
    const w = window.screen.width;
    const h = window.screen.height;

    // ⚠️ NÃO usar noopener aqui (precisamos do window.opener no popup)
    const popup = window.open(url, 'StripeCheckout', `width=${w},height=${h},left=0,top=0`);

    if (!popup) {
      window.location.href = url;
      return;
    }

    const onMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://app.slicksell.com.br') return;

      const data = event.data;
      if (!data || data.type !== 'STRIPE_CHECKOUT_DONE') return;

      window.removeEventListener('message', onMessage);

      try { popup.close(); } catch { }

      const ok = data.result === 'success';

      // ✅ toast só no success
      if (ok) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { billing: 'stripe', result: 'success' },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        }).then(() => window.location.reload());
      } else {
        window.location.reload();
      }
    };

    window.addEventListener('message', onMessage);

    const interval = window.setInterval(() => {
      if (popup.closed) {
        window.clearInterval(interval);
        window.removeEventListener('message', onMessage);
        window.location.reload();
      }
    }, 500);
  }
  //openStripeCheckoutInPopup

  loadingSub: Record<number, boolean> = { 1: false, 2: false, 3: false };

  private setLoading(n: number, v: boolean) {
    this.loadingSub[n] = v;
  }




  ///////////////////////////
  stripePayVisible = false;
  stripeClientSecret = '';
  stripeErrorMsg = '';
  stripePayLoading = false;
  pendingPaymentIntentId = '';
  stripePayPlanName = '';
  stripePayPlanPrice = '';

  invoiceDialogVisible = false;
  invoiceUrl = '';

  private stripe: Stripe | null = null;

  openStripePayment(clientSecret: string, paymentIntentId: string = '') {
    this.stripeClientSecret = clientSecret;
    this.pendingPaymentIntentId = paymentIntentId;
    this.stripePayVisible = true;

    setTimeout(() => this.mountStripePaymentElement(), 50);
  }

  private async mountStripePaymentElement() {
    try {
      this.stripeErrorMsg = '';

      // this.stripe = await loadStripe(
      //   'pk_test_51SpCsW7tku4TFCkCahFDbvst6UEuhjHCuM2EFIBQ5RE3eoqylEe9pdt6zNHqXQdd16YDIU3aplTpzev75zn85uo400T51XCIBy'
      // );
      this.stripe = await this.getStripe();

      if (!this.stripe) {
        this.stripeErrorMsg = 'Stripe não inicializou.';
        return;
      }

      this.elements = this.stripe.elements({
        clientSecret: this.stripeClientSecret,
      });

      const host = document.getElementById('stripe-subscription-payment-element');
      if (!host) {
        this.stripeErrorMsg = 'Container do Stripe não encontrado no DOM.';
        return;
      }

      host.innerHTML = '';

      const paymentElement = this.elements.create('payment');
      paymentElement.mount('#stripe-subscription-payment-element');
    } catch (e: any) {
      this.stripeErrorMsg = e?.message ?? 'Erro ao montar pagamento.';
    }
  }

  async confirmStripePayment() {
    if (!this.stripe || !this.elements) return;

    this.stripePayLoading = true;
    this.stripeErrorMsg = '';

    const { error, paymentIntent } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: 'https://app.slicksell.com.br/conta/assinatura?paid=1',
      },
      redirect: 'if_required',
    });

    if (error) {
      this.stripeErrorMsg = error.message ?? 'Pagamento falhou.';
      this.stripePayLoading = false;
      return;
    }

    if (paymentIntent?.status === 'succeeded') {
      const piId = this.pendingPaymentIntentId || paymentIntent.id;

      const obs = await this.pedidosService.finalizeSubscription(piId);
      obs.subscribe({
        next: (res) => {
          this.stripePayLoading = false;
          this.closeStripePay();
          const invoiceUrl = res?.hosted_invoice_url;
          if (invoiceUrl) {
            this.openInvoiceDialog(invoiceUrl);
          } else {
            this.messageService.add({
              severity: 'success',
              summary: 'Assinatura ativada',
              detail: 'Pagamento confirmado e assinatura ativada com sucesso!'
            });
            setTimeout(() => window.location.reload(), 1500);
          }
        },
        error: (err) => {
          this.stripePayLoading = false;
          this.errorHandler.handle(err, 'Falha ao ativar assinatura após pagamento.');
        }
      });
      return;
    }

    this.stripePayLoading = false;
    this.stripeErrorMsg = 'Pagamento não confirmado. Tente novamente.';
  }

  closeStripePay() {
    this.stripePayVisible = false;
    this.stripeClientSecret = '';
    this.stripeErrorMsg = '';
    this.stripePayLoading = false;
    this.pendingPaymentIntentId = '';
    this.elements = null;
  }

  openInvoiceDialog(url: string) {
    this.invoiceUrl = url;
    this.invoiceDialogVisible = true;
  }

  closeInvoiceDialog() {
    this.invoiceDialogVisible = false;
    this.invoiceUrl = '';
    window.location.reload();
  }



  ///////////////////////////

  confirmDialogVisible: boolean = false; // Controla a exibição do diálogo

  showConfirmDialog() {
    this.confirmDialogVisible = true; // Exibe o p-dialog
  }

  confirmCancelSubscription() {
    this.confirmDialogVisible = false; // Fecha o p-dialog
    this.cancelSubscription(); // Chama o método de cancelamento
  }
  async cancelSubscription() {
    const obs = await this.pedidosService.cancelShopifySubscription();
    obs.subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Assinatura cancelada',
          detail: 'Assinatura cancelada com sucesso.!'
        });
        this.userSubType = 0;
        if (this.userSubType == 0) {
          this.plan = 'Free';
          this.views_total = this.free_plan_views_count;
          this.slicks_total = this.free_plan_videos_count;
        }
        // Atualizar estado da aplicação se necessário
      },
      error: (error) => {
        console.error("Erro ao cancelar a assinatura:", error);

        // Verifica se existe um array de detalhes de erro
        let errorMessage = 'Erro desconhecido ao cancelar assinatura.';
        if (error.error && error.error.details && Array.isArray(error.error.details)) {
          errorMessage = error.error.details.map((err: any) => err.message).join(', ');
        } else if (error.error && error.error.error) {
          errorMessage = error.error.error;
        }

        this.errorHandler.handle(error, errorMessage);
      }
    });

  }

  plan: string = 'Free';
  views_total: number = 500;
  slicks_total: number = 10;
  feeds_total: number = 10;
  free_plan_videos_count: number = 10;
  starter_plan_videos_count: number = 150;
  pro_plan_videos_count: number = 450;
  enterprise_plan_videos_count: number = 999;

  free_plan_views_count: number = 500;
  starter_plan_views_count: number = 15000;
  pro_plan_views_count: number = 50000;
  enterprise_plan_views_count: number = 150000;
  // Função para formatar os números de visualizações
  // Função para formatar os preços como reais (R$)
  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }
  // Função para formatar os números de visualizações
  formatNumber(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }
  // Variáveis para armazenar os valores formatados
  freePlanPrice!: string;
  starterPlanPrice!: string;
  proPlanPrice!: string;
  enterprisePlanPrice!: string;

  freePlanViews!: string;
  starterPlanViews!: string;
  proPlanViews!: string;
  enterprisePlanViews!: string;

  hasShopify!: boolean;
  userSubType!: number;

  openDialogEmail() {
    console.log('openDialogEmail');
    this.showDialog = true
    console.log('openDialogEmail: ' + this.showDialog);
  }
  loadingBtnSecurity: boolean = false;

  async changePassword() {
    this.loadingBtnSecurity = true;

    if (this.checkPass && !this.errorPassword && !this.errorConfirmPassword) {
      this.issueForm = this.fb.group({
        password: this.nova_senha
      });

      try {
        const observable = await this.pedidosService.changePassword(this.issueForm.value);
        observable.subscribe({
          next: (res: any) => {
            console.log('res', res);
            this.loadingBtnSecurity = false;
            this.displaySidebar = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Senha alterada',
              detail: 'A senha foi alterada com sucesso!'
            });
          },
          error: (error: any) => {
            this.loadingBtnSecurity = false;
            console.log('caiu no erro: ' + error);
            let message = '';
            this.saveUser = false;

            if ([400, 401, 403].includes(error.status)) {
              message = error.error.message;
            } else if (error.status === 500) {
              message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
            } else if (error.status !== 404) {
              message = error.error.message;
            }

            if (message) {
              this.showErrorDialog(message);
            }
          }
        });
      } catch (error) {
        this.loadingBtnSecurity = false;
        console.error('Erro ao tentar alterar a senha:', error);
        this.showErrorDialog("Erro inesperado ao alterar a senha.");
      }
    }
  }


  checkPass: boolean = false;
  btnSaveSecurity: boolean = true;
  private debounceTimer: any = null;

  async closeSidebar() {
    this.displaySidebar = false;

    const user_id = localStorage.getItem('user_id');
    if (user_id) {
      const numericUserId = parseInt(user_id, 10);
      this.user_id = numericUserId;

      try {
        // Cache-first com ETag — mesma chave do carregamento inicial; se o
        // usuário salvou algo, o backend muda o ETag e a revalidação em
        // segundo plano já traz o dado novo (não fica preso no cache antigo).
        const userResource = this.pedidosService.detailUserRevalidated(numericUserId);

        toObservable(userResource.data, { injector: this.injector }).pipe(
          filter((response): response is any => response !== null)
        ).subscribe(response => {
            this.user_name = response.name;
            this.user_sobrenome = response.surname;
            this.chat_name = response.username;
            this.email = response.email;
            this.emailFisrt = response.email;

            if (response.photo) {
              const photoUrl = response.photo.split('?')[0];
              this.logoPreviewUrl = photoUrl;
              this.imgUrl = photoUrl;
            }

            this.displayAguarde = false;
            this.toggleSidebar();
        });

        toObservable(userResource.error, { injector: this.injector }).pipe(
          filter((error): error is any => error !== null)
        ).subscribe(error => {
            this.displayAguarde = false;
            console.error('Erro ao carregar usuário:', error);
        });
      } catch (error) {
        this.displayAguarde = false;
        console.error('Erro ao resolver detailUser():', error);
      }
    }
  }

  async checkLogin() {
    this.errorPasswordAtual = false;
    clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(async () => {
      try {
        const res = await this.pedidosService.verifyPassword(this.senha_atual).toPromise();
        console.log('[✔] Senha verificada:', res);

        if (res.valid) {
          if (!this.errorPassword && !this.errorConfirmPassword && this.nova_senha.length >= 6 && this.nova_senha === this.confirm_senha) {
            this.displaySidebar = true;
            this.btnSaveSecurity = false;
            setTimeout(() => this.manageOverlay(), 1);
          }
          this.checkPass = true;
        }
      } catch (err) {
        console.error('❌ Senha incorreta', err);
        this.displaySidebar = false;
        this.checkPass = false;
        this.errorPasswordAtual = true;
        this.btnSaveSecurity = true;
      }
    }, 1500);
  }

  // async checkLogin() {
  //   this.errorPasswordAtual = false;
  //   clearTimeout(this.debounceTimer);
  //   this.debounceTimer = setTimeout(async () => {
  //     const obs = await this.pedidosService.login(this.email, this.senha_atual);
  //     obs.subscribe({
  //       next: (res: any) => {
  //         console.log('res', res);
  //         if (res.access_token) {
  //           localStorage.setItem('access_token', res.access_token);
  //         }
  //         if (!this.errorPassword && !this.errorConfirmPassword && this.nova_senha.length >= 6 && this.nova_senha == this.confirm_senha) {
  //           this.displaySidebar = true;
  //           this.btnSaveSecurity = false;
  //           setTimeout(() => {
  //             this.manageOverlay();
  //           }, 1);
  //         }
  //         this.checkPass = true;
  //       },
  //       error: (error: any) => {
  //         this.displaySidebar = false;
  //         this.checkPass = false;
  //         this.errorPasswordAtual = true;
  //         this.btnSaveSecurity = true;
  //       }
  //     });
  //   }, 1500);

  // }
  showCountSlicks: boolean = true;
  showCountViews: boolean = true;
  selecionarOpcao(opcao: number): void {
    this.activeOption = opcao;
  }


  erroTamanhoImagem: boolean = false;
  erroTipoImagem: boolean = false;

  errorName: boolean = false;
  errorEmail: boolean = false;
  issueForm?: FormGroup;
  // checkInput() {
  //   this.errorName = !this.user_name.trim(); // Atualiza errorName baseado se user_name está vazio ou não
  //   if (!this.errorName) {
  //     this.disableSave = true;
  //     this.displaySidebar = true;
  //     this.manageOverlay();
  //   } 
  // }

  checkInput1() {
    this.errorName = this.user_name.trim().length === 0;
    if (this.errorName) {
      this.disableSave = true;
      this.displaySidebar = false;
    } else {
      this.disableSave = false;
      this.displaySidebar = true;
      setTimeout(() => {
        this.manageOverlay();
      }, 1);
    }

    // const overlay = document.querySelector('.p-component-overlay') as HTMLElement;
    // const overlayEnter = document.querySelector('.p-component-overlay-enter') as HTMLElement;
    // //if (this.displaySidebar) {
    //   console.log('456')
    //   overlay.style.display = 'none';
    //   overlayEnter.style.display = 'none';
    // //}
  }
  checkInput2() {
    this.errorName = this.user_name.trim().length === 0;
    if (this.errorName) {
      this.disableSave = true;
      this.displaySidebar = false;
    } else {
      this.displaySidebar = true;
      this.disableSave = false;
      setTimeout(() => {
        this.manageOverlay();
      }, 1);
    }
  }
  checkInput3() {
    this.errorName = this.user_name.trim().length === 0;
    if (this.errorName) {
      this.disableSave = true;
      this.displaySidebar = false;
    } else {
      this.displaySidebar = true;
      this.disableSave = false;
      setTimeout(() => {
        this.manageOverlay();
      }, 1);
    }
  }
  checkInputEMail() {
    this.errorEmail = !this.email.trim();
    if (this.email !== this.emailFisrt) {
      this.changeEmal = true; //
    }
  }
  saveUser: boolean = false;
  imagePreviewUrl: string | null = null;
  showImageDeleteButton: boolean = false;
  disableSave: boolean = true;
  async saveUserProfile() {



    const cleanedName = (this.user_name ?? '').trim();
    const cleanedSurname = (this.user_sobrenome ?? '').trim();
    const cleanedChatName = (this.chat_name ?? '').trim();

    this.issueForm = this.fb.group({
      name: cleanedName,
      surname: cleanedSurname,
      // Pode ficar vazio: envia null para permitir limpar no backend sem estourar validação de string vazia
      username: cleanedChatName.length ? cleanedChatName : null,
      email: this.emailFisrt,
      photo: this.hasNewLogo ? this.imgUrl : this.logoPreviewUrl,
    });
    if (this.user_id !== undefined) {
      try {
        const obs = await this.pedidosService.saveUser(this.user_id, this.issueForm.value);
        obs.subscribe({
          next: (response) => {
            this.loadingBtn = false;
            this.displayAguarde = false;
            this.saveUser = false;
            this.disableSave = true;
            this.hasNewLogo = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Usuário Salvo',
              detail: 'O usuário foi salvo com sucesso!'
            });
            this.displaySidebar = false;
          },
          error: (error: any) => {
            this.displayAguarde = false;
            this.disableSave = true;
            this.saveUser = false;
            let message = '';
            if (error.status === 400 || error.status === 403 || error.status === 401) {
              message = error.error.message;
            } else if (error.status === 500) {
              message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
            } else if (error.status !== 404) {
              message = error.error.message;
            }

            if (message) {
              this.showErrorDialog(message);
            }
          }
        });
      } catch (e) {
        console.error('Erro ao salvar usuário:', e);
      }
    }

  }
  loadingBtn: boolean = false;
  hasNewLogo: boolean = false;
  imgUrl: string = '';
  saveProfile() {
    this.checkInput1(); // Verifica se o campo está vazio ao tentar salvar
    this.checkInputEMail();
    if (!this.fileUploadIsValid) {
      this.showRequiredError = true;

      return;
    }
    this.displayAguarde = true;
    this.loadingBtn = true;
    console.log('Saving profile');
    if (this.selectedFile) {
      const imageUpload$ = this.uploadFile(this.selectedFile);
      imageUpload$.pipe().subscribe({
        next: (url) => {
          console.log(url); // logoPreviewUrl
          this.imgUrl = url.split('?')[0];
          let cleanUrl = url.split('?')[0];
          this.disableSave = true;
          this.hasNewLogo = true;
          //this.cdr.detectChanges();
          ////// agora ep e salvar
          this.saveUserProfile();
          this.displaySidebar = false;
          this.avatarService.updateAvatar(null); // força o Angular a "zerar"
          setTimeout(() => {
            this.avatarService.updateAvatar(cleanUrl);
          }, 500);
        },
        error: (error) => {

        }
      });
    } else {
      this.saveUserProfile();
    }

  }
  handleSidebarOpen() {
    setTimeout(() => {
      this.manageOverlay();
    }, 1);
  }
  showErrorDialog(message: string) {
    this.confirmationService.confirm({
      message: message,
      header: 'Erro',
      icon: 'pi pi-times',
      accept: () => {
      }
    });
  }
  calculateLeftPosition(value: number): string {
    const max = 1000; // Substitua pelo seu valor máximo
    const percentage = (value / max) * 100;
    return `${percentage}%`;
  }
  calculateLeftPosition2(value: number): string {
    const max = 10; // Substitua pelo seu valor máximo
    const percentage = (value / max) * 100;
    return `${percentage}%`;
  }
  uploadFile(file: File): Observable<string> {
    const userId = localStorage.getItem('user_id') || '';
    return from(this.mediaUploadService.uploadForUser(file, userId, 'profile_photo')).pipe(
      map(({ url }) => url)
    );
  }



  errorPassword: boolean = false;
  errorPasswordAtual: boolean = false;
  errorConfirmPassword: boolean = false;
  checkPassword(): void {
    this.errorPassword = !this.nova_senha || this.nova_senha.length < 6;
    if (!this.errorConfirmPassword && !this.errorPassword && this.checkPass && this.nova_senha.length >= 6 && this.nova_senha == this.confirm_senha) {
      this.btnSaveSecurity = false;
      this.displaySidebar = true;
      setTimeout(() => {
        this.manageOverlay();
      }, 1);
    } else {
      this.displaySidebar = false;
    }
    if (this.nova_senha !== this.confirm_senha) {
      this.displaySidebar = false;
      this.errorConfirmPassword = true;
    }
  }
  checkConfirmPassword(): void {
    this.errorConfirmPassword = this.nova_senha !== this.confirm_senha;
    console.log(!this.errorConfirmPassword)
    console.log(!this.errorPassword)
    console.log(this.checkPass)
    if (!this.errorConfirmPassword && !this.errorPassword && this.checkPass && this.nova_senha.length >= 6 && this.nova_senha == this.confirm_senha) {
      this.btnSaveSecurity = false;
      this.displaySidebar = true;
      setTimeout(() => {
        this.manageOverlay();
      }, 1);
    } else {
      this.displaySidebar = false;
    }
    if (this.nova_senha !== this.confirm_senha) {
      this.displaySidebar = false;
      this.errorConfirmPassword = true;
    }
  }
  display: boolean = false;

  forgot() {
    this.display = true; // Abre o diálogo
  }
  confirmForgot() {
    this.display = false; // Fecha o diálogo
    if (typeof this.emailFisrt === 'string') { // Confirma que emailFisrt é uma string
      this.pedidosService.forgot(this.emailFisrt).subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Email Enviado',
            detail: 'O email foi enviado com sucesso!'
          });
        },
        error: (error) => {
          this.errorHandler.handle(error, 'Houve um problema ao enviar o email.');
        }
      });
    } else {
      // Caso emailFisrt não seja uma string válida, lidar com isso aqui
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Email inválido.'
      });
    }
  }
  newEmail: string = '';
  showDialog: boolean = false;
  // Função para validar email
  isEmailValid: boolean = false;
  isValidEmail(email: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
  debounceTimeout: any;
  onEmailChange(value: string) {
    this.errorEmail = false;
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      this.isEmailValid = this.isValidEmail(value);
      this.errorEmail = !this.isValidEmail(value);
    }, 750);

    // Oculta o erro enquanto o usuário está digitando
    this.errorEmail = false;
  }
  isLoading: boolean = false;
  errorMessage: string = '';
  async updateEmail() {
    if (this.isValidEmail(this.newEmail)) {
      this.errorEmail = false;
      console.log('Email válido:', this.newEmail);
    } else {
      this.errorEmail = true;
    }

    this.errorMessage = '';

    if (this.newEmail) {
      console.log('Email atualizado para:', this.newEmail);
      this.showDialog = false;

      this.issueForm = this.fb.group({
        new_email: this.newEmail
      });

      if (this.user_id) {
        try {
          const observable = await this.pedidosService.changeEmail(this.issueForm.value, this.user_id);
          observable.subscribe({
            next: (response) => {
              this.isLoading = false;
              this.messageService.add({
                severity: 'success',
                summary: 'Email enviado',
                detail: 'O email de confirmação foi enviado com sucesso!'
              });
            },
            error: (error) => {
              this.isLoading = false;
              this.errorHandler.handle(error, 'O email de confirmação não foi enviado. Tente mais tarde, por favor!');
            }
          });
        } catch (e) {
          console.error('Erro ao preparar requisição de troca de email:', e);
          this.isLoading = false;
        }
      }
    }
  }


  private oauthChannel: BroadcastChannel | null = null;
  private popupChecker?: number;
  private oauthHandled = false;
  ngOnDestroy() {
    if (this.oauthChannel) {
      this.oauthChannel.close();
      this.oauthChannel = null;
    }

    // Restaura os overlays para o estado padrão ao sair da página
    const overlays = document.querySelectorAll('.p-component-overlay');
    const overlayEnters = document.querySelectorAll('.p-component-overlay-enter');

    overlays.forEach((overlay: Element) => {
      (overlay as HTMLElement).style.display = ''; // Remove a alteração manual
    });

    overlayEnters.forEach((overlayEnter: Element) => {
      (overlayEnter as HTMLElement).style.display = ''; // Remove a alteração manual
    });

    if (this.popupChecker) clearInterval(this.popupChecker);
  }


  private storageBridge?: BroadcastChannel;

  private setupStorageBridgeForPopup(): void {
    if (this.storageBridge) return;
    this.storageBridge = new BroadcastChannel('oauth-storage');

    this.storageBridge.onmessage = (e) => {
      if (e.data?.type === 'request-storage') {
        // Envie as chaves que a popup precisa
        this.storageBridge?.postMessage({
          type: 'storage-dump',
          payload: {
            SelectedStoreId: localStorage.getItem('ss_SelectedStoreId'),
            user_id: localStorage.getItem('user_id'),
          }
        });
      }
    };
  }



  ////////////////////////
  paymentProvider: 'stripe' | 'shopify' | null = null;
  shopifyBillingUrl: string | null = null;

  historyRows: BillingHistoryRow[] = [];
  loadingHistory = false;
  expandedRows: { [key: string]: boolean } = {};
  providers: Array<'stripe' | 'shopify'> = [];

  stripeRows: BillingHistoryRow[] = [];
  activeHistoryTabIndex = 0; // 0=Stripe, 1=Shopify (ou ao contrário)


  shopifyRows: any[] = []; // linha fake pro shopify
  ////////////////////////

  async loadHistory(): Promise<void> {
    const user_id_tmp = localStorage.getItem('user_id') || '';
    const user_id = Number(user_id_tmp);
    if (!user_id) return;

    this.loadingHistory = true;

    try {
      // Cache-first com ETag.
      const historyResource = this.pedidosService.listHistoryRevalidated(user_id);

      toObservable(historyResource.data, { injector: this.injector }).pipe(
        filter((res): res is any => res !== null)
      ).subscribe(res => {
          this.providers = (res?.providers ?? []) as any;

          // -------- STRIPE
          const stripeHistory = res?.stripe?.history ?? [];
          this.stripeRows = stripeHistory.map((r: any) => {
            const ls = r?.lines_summary;

            if (typeof ls === 'string') {
              try { r.lines_summary = JSON.parse(ls); } catch { r.lines_summary = []; }
            }
            if (!Array.isArray(r.lines_summary)) r.lines_summary = [];
            return r;
          });

          // -------- SHOPIFY
          const shopify = res?.shopify ?? null;
          this.shopifyBillingUrl =
            shopify?.admin_shopify_billing_url ||
            shopify?.shopify_billing_url ||
            null;

          // ✅ cria 1 linha fake pra tabela do Shopify (igual antes aparecia)
          this.shopifyRows = this.providers.includes('shopify')
            ? [{
              provider_invoice_id: 'shopify-billing',
              period_label: 'Shopify',
              hosted_invoice_url: this.shopifyBillingUrl,
              invoice_pdf: null,
              lines_summary: []
            }]
            : [];

          // -------- Aba ativa
          // se tem stripe e shopify: 0=Stripe, 1=Shopify
          // se só shopify: 0=Shopify
          if (this.providers.includes('stripe') && this.providers.includes('shopify')) {
            this.activeHistoryTabIndex = 0;
          } else if (this.providers.includes('stripe')) {
            this.activeHistoryTabIndex = 0;
          } else if (this.providers.includes('shopify')) {
            this.activeHistoryTabIndex = 0;
          }

          this.loadingHistory = false;
      });

      toObservable(historyResource.error, { injector: this.injector }).pipe(
        filter((err): err is any => err !== null)
      ).subscribe(err => {
          console.error('Erro ao listar histórico:', err);
          this.loadingHistory = false;
      });
    } catch (e) {
      console.error('Erro ao preparar request listHistory:', e);
      this.loadingHistory = false;
    }
  }

  private setActiveHistoryTabByProviders() {
    // se só shopify, ativa 0
    if (this.providers.length === 1 && this.providers[0] === 'shopify') {
      this.activeHistoryTabIndex = 0;
      return;
    }
    // se stripe existe, deixe stripe como 0
    if (this.providers.includes('stripe')) {
      this.activeHistoryTabIndex = 0;
    } else {
      this.activeHistoryTabIndex = 0;
    }
  }


  getHistoryCurrency(row: BillingHistoryRow): string {
    const c = String(row?.currency || 'BRL').toUpperCase();
    return c;
  }

  hasProration(row: any): boolean {
    const lines = row?.lines_summary || [];
    return Array.isArray(lines) && lines.some((l: any) => !!l?.proration);
  }



  getHistoryStatusLabel(row: BillingHistoryRow): string {
    const s = String(row?.status || '').toLowerCase();
    if (['paid'].includes(s)) return 'Pago';
    if (['open'].includes(s)) return 'Em aberto';
    if (['draft'].includes(s)) return 'Rascunho';
    if (['void', 'uncollectible'].includes(s)) return 'Cancelado';
    return 'Pendente';
  }


  /** valor: tenta usar amount_cents primeiro, senão amount */
  getHistoryAmount(row: BillingHistoryRow): number {
    return row?.amount_cents != null ? Number(row.amount_cents) / 100 : 0;
  }


  getHistoryLabel(row: BillingHistoryRow): string {
    if (this.paymentProvider === 'shopify') return 'Abrir no Shopify';
    return row?.period_label || '-';
  }


  getHistoryStatus(row: BillingHistoryRow): 'ok' | 'warn' | 'bad' {
    const s = String(row?.status || '').toLowerCase();
    if (['paid', 'succeeded', 'active', 'ok'].includes(s)) return 'ok';
    if (['open', 'pending', 'draft'].includes(s)) return 'warn';
    return 'bad';
  }
  getHistoryLabelPretty(row: BillingHistoryRow): string {
    if (this.paymentProvider === 'shopify') return 'Shopify Billing';
    const label = row?.period_label; // "01/2026"
    if (!label) return '-';
    const [mm, yyyy] = label.split('/');
    const date = new Date(Number(yyyy), Number(mm) - 1, 1);
    return new Intl.DateTimeFormat('pt-BR', { month: 'short', year: 'numeric' }).format(date);
  }

  openInvoice(row: any) {
    // Shopify (linha fake ou caso venha url específica)
    if (this.paymentProvider === 'shopify') {
      const url = row?.hosted_invoice_url || this.shopifyBillingUrl;
      if (!url) return;
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    // Stripe
    const url = row?.hosted_invoice_url || row?.invoice_pdf;
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }



  shopifyIcon = 'assets/shopify_glyph.png';
  stripeIcon = 'assets/498440.webp';

  private setActiveHistoryTabByProvider() {
    // 0 = Stripe, 1 = Shopify (você escolhe a ordem)
    this.activeHistoryTabIndex = this.paymentProvider === 'shopify' ? 1 : 0;
  }

  /////// novo cards stripe
  cardDialogVisible = false;
  loadingCard = false;
  submitting = false;

  private elements: StripeElements | null = null;
  private clientSecret: string | null = null;

  // pegue do env
  private stripePk = environment.stripePublishableKey;

  addCard() {
    this.cardDialogVisible = true;
  }
  private paymentElement?: any;


  async onCardDialogShow() {
    this.loadingCard = true;
  
    const obs = await this.pedidosService.createCardSetupIntent();
    obs.subscribe({
      next: async (res) => {
        try {
          this.clientSecret = res?.client_secret;
          this.customerId = res?.customer_id ?? null;
          if (!this.clientSecret) throw new Error('client_secret não veio do backend');
  
          // ✅ Stripe só aqui
          this.stripe = await this.getStripe();
          if (!this.stripe) throw new Error('Stripe não inicializou');
  
          this.loadingCard = false;
          this.cdr.detectChanges();
          await new Promise<void>((r) => requestAnimationFrame(() => r()));
  
          const scheme = this.layoutService.config.colorScheme;
          const stripeTheme = scheme === 'light' ? 'stripe' : 'night';
  
          this.elements = this.stripe.elements({
            clientSecret: this.clientSecret,
            appearance: { theme: stripeTheme },
          });
  
          this.paymentElement = this.elements.create('payment');
          this.paymentElement.mount('#stripe-payment-element');
        } catch (e) {
          this.loadingCard = false;
          console.error(e);
        }
      },
      error: (err) => {
        this.loadingCard = false;
        console.error(err);
      }
    });
  }


  onCardDialogHide() {
    try { this.paymentElement?.unmount?.(); } catch { }

    // ✅ limpa artefatos globais que ficam no body
    this.cleanupStripeArtifacts();

    this.paymentElement = null;
    this.elements = null;
    this.clientSecret = null;
    this.loadingCard = false;
    this.submitting = false;

    // opcional: limpa o container também
    const el = document.querySelector('#stripe-payment-element');
    if (el) el.innerHTML = '';
  }


  private cleanupStripeArtifacts(): void {
    // Remove iframes/wrappers que a Stripe injeta globalmente (helper/badge)
    const selectors = [
      'iframe[name^="__privateStripeFrame"]',
      'iframe[name^="__PrivateStripeFrame"]',
      'iframe[src*="stripe.com"]',
      'div[id^="stripe-"]',
      'div[class*="Stripe"]',
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach((el) => {
        // evita remover o container do seu element, então garanta que não é o alvo
        if ((el as HTMLElement).id === 'stripe-payment-element') return;
        // remove apenas itens fora do dialog/container
        const parent = (el as HTMLElement).parentElement;
        // normalmente esses overlays ficam direto no body
        if (parent && (parent === document.body || parent.parentElement === document.body)) {
          parent.removeChild(el);
        }
      });
    });
  }

  customerId: string | null = null;

  async submitCard() {
    if (!this.stripe || !this.elements) return;

    this.submitting = true;

    // 5) confirma o SetupIntent usando os dados do Payment Element
    // Stripe recomenda confirmSetup para SetupIntent com Payment Element. :contentReference[oaicite:3]{index=3}
    const result = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: {
        // se precisar redirecionar (3DS), Stripe usa esse return_url
        return_url: 'https://app.slicksell.com.br/profile#subscription'
      },
      redirect: 'if_required'
    });

    if (result.error) {
      this.submitting = false;
      console.error(result.error.message);
      return;
    }

    // 6) Pegue o payment_method do SetupIntent confirmado
    const setupIntent = result.setupIntent;
    const paymentMethodId =
      typeof setupIntent.payment_method === 'string'
        ? setupIntent.payment_method
        : setupIntent.payment_method?.id;

    if (!paymentMethodId) {
      this.submitting = false;
      console.error('payment_method não veio no SetupIntent');
      return;
    }

    // 7) valida CVC check antes de salvar
    const pm = setupIntent.payment_method;
    const cvcCheck = (typeof pm === 'object' && pm !== null)
      ? (pm as any)?.card?.checks?.cvc_check
      : null;

    if (cvcCheck === 'fail') {
      this.submitting = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Cartão inválido',
        detail: 'O código de segurança (CVC) informado é inválido.',
      });
      return;
    }

    const obs = await this.pedidosService.attachCard(paymentMethodId, this.customerId);


    obs.subscribe({
      next: async () => {
        this.submitting = false;
        this.cardDialogVisible = false;
        // aqui você pode recarregar lista de cartões do usuário
        this.messageService.add({
          severity: 'success',
          summary: 'Cartão adicionado',
          detail: 'O cartão foi adicionado com sucesso.',
        });
        // ✅ recarrega lista para atualizar o carousel
        await this.loadCards();
      },
      error: (err) => {
        this.submitting = false;
        this.errorHandler.handle(err, 'Falha ao cadastrar cartão.');
        console.error(err);
      }
    });
  }
  confirmRemoveCard(card: any) {
    const pmId = card?.id;
    if (!pmId) return;

    this.confirmationService.confirm({
      header: 'Remover cartão',
      message: `Tem certeza que deseja remover o cartão ${this.getMaskedNumber(card)}?`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Remover',
      rejectLabel: 'Cancelar',
      accept: () => this.removeCard(pmId),
    });
  }

  async removeCard(paymentMethodId: string) {
    const user_id = Number(localStorage.getItem('user_id')) || 0;
    if (!user_id) return;

    this.loadingCards = true;

    try {
      const obs = await this.pedidosService.removeCard(user_id, paymentMethodId);
      obs.subscribe({
        next: async () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Cartão removido',
            detail: 'O cartão foi removido com sucesso.',
          });

          // recarrega lista
          await this.loadCards();
        },
        error: (err) => {
          this.loadingCards = false;
          const msg = err?.error?.message ?? 'Erro ao remover cartão';
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
        }
      });
    } catch (e) {
      this.loadingCards = false;
      console.error(e);
    }
  }

  /////// novo cards stripe
}

